export const ADD_PLAYS = "ADD_PLAYS";
export const ADD_PLAYS_COMPLETE = "ADD_PLAYS_COMPLETE";
export const START_PLAY = "START_PLAY";
export const SAVE_PLAY = "SAVE_PLAY";
export const SAVE_PLAY_COMPLETE = "SAVE_PLAY_COMPLETE";
export const GET_PLAY = "GET_PLAY";
export const GET_PLAY_COMPLETE = "GET_PLAY_COMPLETE";
export const GO_BACK = "GO_BACK";
export const GO_BACK_COMPLETE = "GO_BACK_COMPLETE";
export const GO_FORWARD = "GO_FORWARD";
export const GO_FORWARD_COMPLETE = "GO_FORWARD_COMPLETE";
export const END_PLAY = "END_PLAY";
export const DELETE_PLAY = "DELETE_PLAY";
export const DELETE_PLAY_COMPLETE = "DELETE_PLAY_COMPLETE";
export const SET_SHOW_DATA_SELECTORS = "SET_SHOW_DATA_SELECTORS";
export const START_OVER = "START_OVER";
export const INIT_PLAYS_DATA = "INIT_PLAYS_DATA";
export const INIT_PLAYS_DATA_COMPLETE = "INIT_PLAYS_DATA_COMPLETE";
export const APPLY_FILTER = "APPLY_FILTER";
export const GO_BACK_TO_COMPLETE = "GO_BACK_TO_COMPLETE";
export const START_TRANSITION = "START_TRANSITION";
export const START_TRANSITION_COMPLETE = "START_TRANSITION_COMPLETE";
export const SAVE_FRAGMENT = "SAVE_FRAGMENT";
export const SAVE_FRAGMENT_COMPLETE = "SAVE_FRAGMENT_COMPLETE";
export const SAVE_EDIT_PLAY = "SAVE_EDIT_PLAY";
export const SAVE_EDIT_PLAY_COMPLETE = "SAVE_EDIT_PLAY_COMPLETE";
export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const CREATE_START_PLAYS_COMPLETE = "CREATE_START_PLAYS_COMPLETE";
export const START_FOOTBALL_GAME_COMPLETE = "START_FOOTBALL_GAME_COMPLETE";
export const FINALIZE_PLAY_COMPLETE = "FINALIZE_PLAY_COMPLETE";
export const TOGGLE_EDIT_PLAY_MODE = "TOGGLE_EDIT_PLAY_MODE";
export const REFRESH_PLAYS_COMPLETE = "REFRESH_PLAYS_COMPLETE";
export const UPDATE_PLAY_STATE = "UPDATE_PLAY_STATE";
export const INSERT_PLAY_COMPLETE = "INSERT_PLAY_COMPLETE";
export const GAME_CONTROL = "GAME_CONTROL";
export const UPDATE_STEPS = "UPDATE_STEPS";
export const REFRESH_PARTICIPANTS = "REFRESH_PARTICIPANTS";
export const REFRESH_PARTICIPANTS_COMPLETE = "REFRESH_PARTICIPANTS_COMPLETE";
export const REVERT_TO_TRANSITION = "REVERT_TO_TRANSITION";
export const REVERT_TO_TRANSITION_COMPLETE = "REVERT_TO_TRANSITION_COMPLETE";
